import { Form, FormHandlers } from '@doveit/bricks';
import React, { MutableRefObject } from 'react';
import * as styles from './AgencyDescriptionForm.style';

export interface AgencyDescriptionFormModel {
  description: string,
}

export interface AgencyDescriptionFormProps {
  initialValues?: Partial<AgencyDescriptionFormModel>,
  innerRef?: MutableRefObject<FormHandlers>
  loading?: boolean,
  onSubmit: (values: AgencyDescriptionFormModel) => void,
}

const AGENCY_DESCRIPTION_FORM_DEFAULT_VALUES: AgencyDescriptionFormModel = {
  description: '',
};

const AgencyDescriptionForm: React.FC<AgencyDescriptionFormProps> = ({
  initialValues,
  loading = false,
  onSubmit,
  innerRef,
}) => {
  const mergedInitialValues: AgencyDescriptionFormModel = React.useMemo(() => ({
    ...AGENCY_DESCRIPTION_FORM_DEFAULT_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      loading={loading}
      onSubmit={onSubmit}
      css={styles.form}
      innerRef={innerRef}
    >
      <Form.Item>
        <Form.TextArea
          label="Descrizione"
          aria-label="Campo per inserire la descrizione dell'agenzia"
          name="description"
          rows={2}
        />
      </Form.Item>
    </Form>
  );
};

export default AgencyDescriptionForm;
